import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes.ts'

import {
  type InsuranceOrderCardProps,
  MyOrderList,
  MyOrdersSupport,
} from 'entities/common/my-ticket'

import { BottomNavigation } from 'shared/ui/bottom-navigation'
import { HeaderButton } from 'shared/ui/header-button'

import s from './styles.module.scss'

const MyOrders = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onClick = () => {
    navigate(RoutingPaths.myOrders.pathArchive())
  }

  const onGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1)

      return
    }

    navigate(RoutingPaths.path())
  }

  const onPayInsuranceOrder = (order: InsuranceOrderCardProps) => {
    navigate(RoutingPaths.insurance.calculation.path(), {
      state: { insuranceOrder: order },
    })
  }

  return (
    <div className={clsx('container', s.container)}>
      <HeaderButton
        variant="grey"
        title={t('my_orders')}
        buttonTitle={t('archive')}
        onClick={onClick}
        onBack={onGoBack}
      />

      <MyOrderList
        isActive
        onPayInsuranceOrder={onPayInsuranceOrder}
      />

      <div className={s.support}>
        <MyOrdersSupport />
      </div>

      <BottomNavigation activeId="orders" />
    </div>
  )
}

export default MyOrders
